module.exports = __webpack_public_path__ + "media/images/logo_mv-2c5871bc20e2dab430e7af0b8fe7ad70.png";